
import get from 'lodash/get';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	inject: ['$validator'],
})
export default class FormError extends Vue {
	@Prop(String)
	public error!: string;

	@Prop(String)
	public name!: string;

	@Prop(String)
	public rule!: string;

	public get hasDefaultSlot(): boolean {
		return (
			!this.name &&
			!this.error &&
			!!get(this.$slots, 'default.0.text.length', 0)
		);
	}
}
